(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4408,2576,5124,949,6818,9600],{

/***/ 62034:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(65067),
    isFlattenable = __webpack_require__(95882);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ 93401:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(24303),
    isArrayLike = __webpack_require__(67878);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ 23813:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(50343),
    baseGet = __webpack_require__(13324),
    baseIteratee = __webpack_require__(68286),
    baseMap = __webpack_require__(93401),
    baseSortBy = __webpack_require__(27095),
    baseUnary = __webpack_require__(47826),
    compareMultiple = __webpack_require__(18477),
    identity = __webpack_require__(23059),
    isArray = __webpack_require__(86152);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),

/***/ 27095:
/***/ (function(module) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),

/***/ 27520:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(4795);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),

/***/ 18477:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var compareAscending = __webpack_require__(27520);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),

/***/ 95882:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(50857),
    isArguments = __webpack_require__(79631),
    isArray = __webpack_require__(86152);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ 829:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(62034),
    baseOrderBy = __webpack_require__(23813),
    baseRest = __webpack_require__(36060),
    isIterateeCall = __webpack_require__(82406);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),

/***/ 87993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/templates/Navigation2/index.ts + 91 modules
var Navigation2 = __webpack_require__(92609);
// EXTERNAL MODULE: ../../libs/templates/GettingStarted/index.ts + 2 modules
var GettingStarted = __webpack_require__(42576);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/api/routes/recipes/queries/index.ts + 8 modules
var queries = __webpack_require__(67723);
// EXTERNAL MODULE: ../../libs/utils/useRichTextTableOfContent/index.ts + 1 modules
var useRichTextTableOfContent = __webpack_require__(43906);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/components/Badge/index.ts + 2 modules
var Badge = __webpack_require__(16154);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/matcha/recipes/AuthorCard/index.ts + 2 modules
var AuthorCard = __webpack_require__(80077);
// EXTERNAL MODULE: ../../libs/utils/contentfulImageLoader/contentfulImageLoader.ts
var contentfulImageLoader = __webpack_require__(1959);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Recipes/SinglePage/components/Hero/AuthorsBox.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var AuthorsBox = function AuthorsBox(_ref) {
  var authors = _ref.authors;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: authors.map(function (_ref2, key) {
      var name = _ref2.name,
          avatar = _ref2.avatar,
          width = _ref2.width,
          height = _ref2.height;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AuthorCard/* default */.ZP, {
        variant: "transparent",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AuthorAvatarsWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledAuthorAvatar, {
            loader: contentfulImageLoader/* default */.Z,
            src: avatar,
            width: width,
            height: height,
            alt: name
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AuthorCard/* Body */.uT, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AuthorCard/* Name */.VG, {
            children: ["Made by ", name]
          })
        })]
      }, key);
    })
  });
};

var AuthorAvatarsWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e4x9m7l1"
} : 0)( true ? {
  name: "k0ippd",
  styles: "display:grid;grid-auto-flow:column"
} : 0);

var StyledAuthorAvatar = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(AuthorCard/* Avatar */.qE,  true ? {
  target: "e4x9m7l0"
} : 0)( true ? {
  name: "1mfsro6",
  styles: "width:40px;height:40px"
} : 0);

/* harmony default export */ var Hero_AuthorsBox = (AuthorsBox);
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Brandbook.ts + 92 modules
var Brandbook = __webpack_require__(79550);
// EXTERNAL MODULE: ../../libs/matcha/components/IconWrapper/index.ts + 2 modules
var IconWrapper = __webpack_require__(79600);
;// CONCATENATED MODULE: ./src/views/Recipes/SinglePage/components/Hero/RequirementList.tsx


function RequirementList_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var copy = {
  heading: "What do you need?"
};

var RequirementList = function RequirementList(_ref) {
  var requirements = _ref.requirements;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
      tag: "h2",
      variant: "h5",
      children: copy.heading
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
      tag: "ul",
      columns: 1,
      gap: "small",
      children: requirements.map(function (requirement) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledFeatureBoxBase, {
          tag: "li",
          alignment: "left",
          headerPosition: "left",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Header */.h4, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper/* default */.Z, {
              variant: "circle",
              elevation: 1,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* CheckIcon */.nQ, {})
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Body */.uT, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
              children: requirement
            })
          })]
        }, requirement);
      })
    })]
  });
};

var StyledFeatureBoxBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(FeatureBox/* default */.ZP,  true ? {
  target: "e1hxka7k0"
} : 0)( true ? {
  name: "1h3rtzg",
  styles: "align-items:center"
} : 0);

/* harmony default export */ var Hero_RequirementList = (RequirementList);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
;// CONCATENATED MODULE: ./src/views/Recipes/SinglePage/components/Hero/Cta.tsx


function Cta_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/* eslint-disable camelcase */





var Cta_copy = {
  heading: "Easily personalize customer experiences with first-party data",
  description: "With a huge integration catalog and plenty of no-code features, Segment provides easy-to-maintain capability to your teams with minimal engineering effort. Great data doesn't have to be hard work!",
  link: "Get started for free"
};

var Cta = function Cta(_ref) {
  var title = _ref.title;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledColumnTrack, {
    columns: 1,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
        tag: "h2",
        variant: "h5",
        children: title && title !== "" ? title : Cta_copy.heading
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
        variant: "pMedium",
        children: Cta_copy.description
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
      linkToApp: false,
      size: "medium",
      additionalParams: {
        utm_source: "site",
        utm_medium: "referral",
        utm_campaign: "all_devrel_recipes-cta"
      },
      children: Cta_copy.link
    })]
  });
};

var StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "e1caik9h0"
} : 0)( true ? {
  name: "p79mp2",
  styles: "row-gap:40px;justify-items:start"
} : 0);

/* harmony default export */ var Hero_Cta = (Cta);
;// CONCATENATED MODULE: ./src/views/Recipes/SinglePage/components/Hero/Hero.tsx


function Hero_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var recipesLink = {
  text: "Recipes",
  href: "/recipes"
};

var Hero_Hero = function Hero(_ref) {
  var heading = _ref.heading,
      description = _ref.description,
      authors = _ref.authors,
      badges = _ref.badges,
      requirements = _ref.requirements,
      ctaAdTitle = _ref.ctaAdTitle;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeroRecipeBase, {
      variant: "2Col",
      copyVariant: "wide",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeroCopy, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
          href: recipesLink.href,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButtonText, {
            tag: "span",
            iconStart: Common/* ChevronLeftIcon */.wy,
            children: recipesLink.text
          })
        }), badges && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BadgesWrapper, {
          children: badges.map(function (badge) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
              variant: "outlined",
              children: badge
            }, badge);
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h1",
            variant: "h1",
            children: heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pExtraLarge",
            children: description
          })]
        }), authors && authors.length && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_AuthorsBox, {
          authors: authors
        })]
      }), requirements && requirements.length && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeroContents, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_RequirementList, {
          requirements: requirements
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Cta, {
          title: ctaAdTitle
        })]
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e1kta99r5"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var StyledHeroRecipeBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Hero/* default */.ZP,  true ? {
  target: "e1kta99r4"
} : 0)(Hero/* Wrapper */.im, "{align-items:start;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("md");
}, "{padding-top:80px;padding-bottom:80px;}", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("lg");
}, "{grid-template-columns:minmax(472px, 60%) minmax(280px, 40%);}", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("xl");
}, "{grid-template-columns:minmax(612px, 65%) minmax(308px, 35%);}", function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.up("xxl");
}, "{grid-template-columns:minmax(852px, 60%) minmax(308px, 40%);}}" + ( true ? "" : 0));

var StyledHeroCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Hero/* Copy */.CK,  true ? {
  target: "e1kta99r3"
} : 0)("text-align:left;display:grid;justify-items:start;row-gap:24px;", function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.up("md");
}, "{row-gap:40px;}", function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoints.up("xxl");
}, "{row-gap:32px;}" + ( true ? "" : 0));

var StyledButtonText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e1kta99r2"
} : 0)("margin-bottom:6px;", function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoints.up("sm");
}, "{margin-bottom:16px;}", function (_ref10) {
  var theme = _ref10.theme;
  return theme.breakpoints.up("md");
}, "{margin-bottom:0;}", function (_ref11) {
  var theme = _ref11.theme;
  return theme.breakpoints.up("xxl");
}, "{margin-bottom:8px;}" + ( true ? "" : 0));

var StyledHeroContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Hero/* Contents */.AU,  true ? {
  target: "e1kta99r1"
} : 0)("text-align:left;max-width:520px;display:grid;row-gap:40px;", function (_ref12) {
  var theme = _ref12.theme;
  return theme.breakpoints.up("lg");
}, "{padding-top:70px;}" + ( true ? "" : 0));

var BadgesWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1kta99r0"
} : 0)( true ? {
  name: "cl7urv",
  styles: "display:flex;flex-wrap:wrap;gap:8px"
} : 0);

/* harmony default export */ var components_Hero_Hero = (Hero_Hero);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/Media/index.ts + 2 modules
var Media = __webpack_require__(75091);
// EXTERNAL MODULE: ../../libs/matcha/components/Select/index.ts + 9 modules
var Select = __webpack_require__(44502);
// EXTERNAL MODULE: ../../libs/matcha/components/Select/useSelect/index.ts + 3 modules
var useSelect = __webpack_require__(27431);
// EXTERNAL MODULE: ../../libs/matcha/components/Input/index.ts + 2 modules
var Input = __webpack_require__(94261);
// EXTERNAL MODULE: ../../libs/matcha/recipes/TableOfContents/index.ts + 8 modules
var TableOfContents = __webpack_require__(55979);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
;// CONCATENATED MODULE: ./src/views/Recipes/SinglePage/components/Sidebar/Sidebar.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var Sidebar = function Sidebar(_ref) {
  var id = _ref.id,
      data = _ref.data;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      greaterThanOrEqual: "xl",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toc, {
        data: data
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      lessThan: "xl",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileSelect, {
        id: id,
        data: data
      })
    })]
  });
};

var Toc = function Toc(_ref2) {
  var data = _ref2.data;

  var _useTableOfContents = (0,TableOfContents/* useTableOfContents */.e9)({
    ids: data.map(function (el) {
      return el.value;
    })
  }),
      activeElementId = _useTableOfContents.activeElementId;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TableOfContents/* default */.ZP, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableOfContents/* Title */.Dx, {
      children: "On this page"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableOfContents/* List */.aV, {
      children: data.map(function (item) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableOfContentsItem, {
          slug: item.value,
          text: item.text,
          active: activeElementId === item.value
        }, item.value);
      })
    })]
  });
};

var MobileSelect = function MobileSelect(_ref3) {
  var id = _ref3.id,
      data = _ref3.data;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();

  var _useSelect = (0,useSelect/* default */.Z)({
    options: data,
    id: id,
    onSelect: function onSelect(e) {
      var _e$;

      (0,useScrollToAnchor/* scrollToAnchor */.d)((_e$ = e[0]) === null || _e$ === void 0 ? void 0 : _e$.value, -100);
    },
    config: {
      mobileConfirmationBehaviour: false
    },
    label: "Select a section"
  }),
      state = _useSelect.state,
      getControlProps = _useSelect.getControlProps,
      filteredOptions = _useSelect.filteredOptions,
      getSelectProps = _useSelect.getSelectProps;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, _objectSpread({
      name: id,
      rightSecondIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronDownIcon */.v4, {
        color: theme.palette.brand.darkAcai[700]
      })
    }, getControlProps({
      placeholder: "Go to section"
    }))), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select/* default */.ZP, _objectSpread({
      id: "select-base-".concat(id),
      name: "select-base-".concat(id),
      options: data,
      filteredOptions: filteredOptions,
      displayMode: "mobile",
      open: state.open,
      modalHeadline: "Go to section"
    }, getSelectProps()))]
  });
};

var TableOfContentsItem = function TableOfContentsItem(_ref4) {
  var slug = _ref4.slug,
      text = _ref4.text,
      active = _ref4.active;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableOfContents/* ListItem */.HC, {
    borderDirection: "left",
    href: "#".concat(slug),
    onClick: function onClick(e) {
      e.preventDefault();
      (0,useScrollToAnchor/* scrollToAnchor */.d)(slug, -100);
    },
    active: active,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableOfContents/* LeftContent */.PJ, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableOfContents/* Text */.xv, {
        variant: "pSmall",
        children: text
      })
    })
  });
};

/* harmony default export */ var Sidebar_Sidebar = (Sidebar);
// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(82562);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/recipes/RichText/index.ts
var RichText = __webpack_require__(47756);
;// CONCATENATED MODULE: ./src/views/Recipes/SinglePage/components/Content/Content.tsx



function Content_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var Content = function Content(_ref) {
  var data = _ref.data,
      tableOfContentState = _ref.tableOfContentState;
  var options = (0,react.useMemo)(function () {
    return {
      renderMark: (0,defineProperty/* default */.Z)({}, dist.MARKS.BOLD, function (text) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Bold, {
          children: text
        });
      }),
      renderNode: (0,defineProperty/* default */.Z)({}, dist.BLOCKS.HEADING_2, function (node, children) {
        var id = tableOfContentState.getId(node);
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
          variant: "h2",
          tag: "h2",
          id: id,
          children: children
        });
      })
    };
  }, [tableOfContentState]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("section", {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText/* default */.ZP, {
      data: data,
      options: options
    })
  });
};

/* harmony default export */ var Content_Content = (Content);

var Bold = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("b",  true ? {
  target: "eestj5s0"
} : 0)( true ? {
  name: "16ceglb",
  styles: "font-weight:600"
} : 0);
;// CONCATENATED MODULE: ./src/views/Recipes/SinglePage/SinglePage.tsx



function SinglePage_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

















var RecipesSinglePageView = function RecipesSinglePageView(_ref) {
  var slug = _ref.slug;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();

  var _useSingleRecipeQuery = (0,queries/* useSingleRecipeQuery */.id)({
    args: [slug]
  }),
      data = _useSingleRecipeQuery.data;

  if (!data) return null;
  var content = data.content,
      title = data.title,
      description = data.description,
      metaDescription = data.metaDescription,
      ogImage = data.ogImage,
      authors = data.authors,
      requirements = data.requirements,
      ctaAdTitle = data.ctaAdTitle,
      industries = data.industries;
  var tableOfContentState = (0,useRichTextTableOfContent/* default */.Z)(content);
  var contentHeadingsOptions = (0,react.useMemo)(function () {
    return tableOfContentState.getMenuLevelItems(0).map(function (_ref2) {
      var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 2),
          node = _ref3[0],
          id = _ref3[1];

      return {
        text: (0,useRichTextTableOfContent/* getNodeText */.q)(node),
        value: id
      };
    });
  }, [tableOfContentState]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: title,
      pageDescription: metaDescription,
      pageOG: ogImage === null || ogImage === void 0 ? void 0 : ogImage.src,
      themeColor: theme.palette.neutrals.white[100],
      bodyBackground: theme.palette.neutrals.white[100],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation2/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Hero_Hero, {
        heading: title,
        description: description,
        authors: authors === null || authors === void 0 ? void 0 : authors.map(function (author) {
          return {
            name: author.name,
            avatar: author.headshot.src,
            width: author.headshot.width,
            height: author.headshot.height
          };
        }),
        requirements: requirements,
        ctaAdTitle: ctaAdTitle,
        badges: industries
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
          variant: "sidebar",
          sidebarSize: "small",
          sticky: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Sidebar */.YE, {
            as: "aside",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Sticky */.Le, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Sidebar_Sidebar, {
                id: "sidebar",
                data: contentHeadingsOptions
              })
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionContents, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Content_Content, {
              data: content,
              tableOfContentState: tableOfContentState
            })
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted["default"], {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
    })
  });
};

var StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e1gwhmnt1"
} : 0)( true ? {
  name: "d3v9zr",
  styles: "overflow:hidden"
} : 0);

/* harmony default export */ var SinglePage = (RecipesSinglePageView);

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e1gwhmnt0"
} : 0)( true ? "" : 0);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var contexts_staticSiteBackend = __webpack_require__(86708);
;// CONCATENATED MODULE: ./src/pages/recipes/[slug].tsx





var RecipesSinglePage = function RecipesSinglePage(_ref) {
  var slug = _ref.slug;
  var staticSiteBackend = (0,react.useMemo)(function () {
    return (0,contexts_staticSiteBackend/* createStaticSiteBackend */.I4)();
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(contexts_staticSiteBackend/* StaticSiteBackendProvider */.D1, {
    value: staticSiteBackend,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SinglePage, {
      slug: slug
    })
  });
};

var __N_SSG = true;
/* harmony default export */ var _slug_ = (RecipesSinglePage);

/***/ }),

/***/ 57447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ei": function() { return /* binding */ useRecipesIndex; },
/* harmony export */   "vS": function() { return /* binding */ AlgoliaClientProvider; }
/* harmony export */ });
/* unused harmony exports AlgoliaClientContext, useAlgoliaClient, createRecipesIndex, useRecipesSearchIndex, createRecipesSearchIndex */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* provided dependency */ var process = __webpack_require__(34406);

var AlgoliaClientContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var AlgoliaClientProvider = AlgoliaClientContext.Provider;
var useAlgoliaClient = function useAlgoliaClient() {
  var AlgoliaClient = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AlgoliaClientContext);

  if (!AlgoliaClient) {
    throw new Error("Recipes index isn't available. Please set it via AlgoliaClientProvider component.");
  }

  return AlgoliaClient;
};
var useRecipesIndex = function useRecipesIndex() {
  var client = useAlgoliaClient();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return createRecipesIndex(client);
  }, [client]);
};
var createRecipesIndex = function createRecipesIndex(client) {
  var _process$env$NEXT_PUB;

  var internalClient = client;
  return internalClient.initIndex((_process$env$NEXT_PUB = "Recipes") !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : "");
};
var useRecipesSearchIndex = function useRecipesSearchIndex() {
  var client = useAlgoliaClient();
  return useMemo(function () {
    return createRecipesSearchIndex(client);
  }, [client]);
};
var createRecipesSearchIndex = function createRecipesSearchIndex(client) {
  var _process$env$NEXT_PUB2;

  var internalClient = client;
  return internalClient.initIndex((_process$env$NEXT_PUB2 = process.env.NEXT_PUBLIC_ALGOLIA_INDEX_NAME_RECIPES_SEARCH) !== null && _process$env$NEXT_PUB2 !== void 0 ? _process$env$NEXT_PUB2 : "");
};

/***/ }),

/***/ 67723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d_": function() { return /* reexport */ useFeaturedRecipesQuery; },
  "s_": function() { return /* reexport */ useFiltersQuery; },
  "R0": function() { return /* reexport */ useRecipesQuery; },
  "id": function() { return /* reexport */ useSingleRecipeQuery; }
});

// UNUSED EXPORTS: createAllRecipesQuery, createFeaturedRecipesQuery, createFiltersQuery, createRecipesQuery, createSingleRecipeQuery, useAllRecipesQuery

// EXTERNAL MODULE: ../../libs/utils/createQueryHook/createQueryHook.ts
var createQueryHook = __webpack_require__(74048);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var staticSiteBackend = __webpack_require__(86708);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(829);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ../../libs/api/types/recipe.ts
var isTool = function isTool(value) {
  return ["name", "type"].every(function (key) {
    return key in value;
  });
};
;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/recipes.ts






function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var fetchAllRecipes = function fetchAllRecipes(client, options) {
  return client.get("/content/entries/recipe", options).then(function (res) {
    var transformedResponse = res.map(function (recipe) {
      var _recipe$authors, _recipe$ogImage, _recipe$ogImage2, _recipe$requiredTools, _recipe$useCases;

      return _objectSpread(_objectSpread({}, recipe), {}, {
        authors: (_recipe$authors = recipe.authors) === null || _recipe$authors === void 0 ? void 0 : _recipe$authors.map(function (author) {
          var _author$fields$headsh, _author$fields$headsh2, _author$fields$compan, _author$fields$compan2;

          return _objectSpread(_objectSpread({}, author.fields), {}, {
            headshot: {
              title: author.fields.headshot.fields.title,
              src: author.fields.headshot.fields.file.url,
              width: (_author$fields$headsh = author.fields.headshot.fields.file.details.image) === null || _author$fields$headsh === void 0 ? void 0 : _author$fields$headsh.width,
              height: (_author$fields$headsh2 = author.fields.headshot.fields.file.details.image) === null || _author$fields$headsh2 === void 0 ? void 0 : _author$fields$headsh2.height
            },
            companyLogo: {
              title: (_author$fields$compan = author.fields.companyLogo) === null || _author$fields$compan === void 0 ? void 0 : _author$fields$compan.fields.title,
              src: (_author$fields$compan2 = author.fields.companyLogo) === null || _author$fields$compan2 === void 0 ? void 0 : _author$fields$compan2.fields.file.url
            }
          });
        }),
        ogImage: {
          src: (_recipe$ogImage = recipe.ogImage) === null || _recipe$ogImage === void 0 ? void 0 : _recipe$ogImage.fields.file.url,
          title: (_recipe$ogImage2 = recipe.ogImage) === null || _recipe$ogImage2 === void 0 ? void 0 : _recipe$ogImage2.fields.title
        },
        requiredTools: (_recipe$requiredTools = recipe.requiredTools) === null || _recipe$requiredTools === void 0 ? void 0 : _recipe$requiredTools.map(function (tool) {
          return tool.fields;
        }),
        useCases: (_recipe$useCases = recipe.useCases) === null || _recipe$useCases === void 0 ? void 0 : _recipe$useCases.map(function (useCase) {
          return useCase.fields;
        })
      });
    });
    return sortBy_default()(transformedResponse, function (item) {
      return item.title;
    });
  });
};
var fetchFeaturedRecipes = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var client, _ref$max, max, options, data;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            client = _ref.client, _ref$max = _ref.max, max = _ref$max === void 0 ? 3 : _ref$max, options = _ref.options;
            _context.next = 3;
            return fetchAllRecipes(client, options);

          case 3:
            data = _context.sent.filter(function (item) {
              return item.featured;
            }).slice(0, max);
            return _context.abrupt("return", data);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFeaturedRecipes(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var fetchRecipe = /*#__PURE__*/function () {
  var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(_ref3) {
    var client, options, slug, data;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            client = _ref3.client, options = _ref3.options, slug = _ref3.slug;
            _context2.next = 3;
            return fetchAllRecipes(client, options);

          case 3:
            data = _context2.sent.find(function (item) {
              return item.slug === slug;
            });
            return _context2.abrupt("return", data);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchRecipe(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
var fetchFilters = /*#__PURE__*/function () {
  var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(_ref5) {
    var client, filtersObjs, options, allRecipes, filters;
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            client = _ref5.client, filtersObjs = _ref5.filtersObjs, options = _ref5.options;
            _context3.next = 3;
            return fetchAllRecipes(client, options);

          case 3:
            allRecipes = _context3.sent;
            filters = filtersObjs.map(function (_ref7) {
              var id = _ref7.id,
                  displayName = _ref7.displayName,
                  searchableId = _ref7.searchableId;
              var options = allRecipes.reduce(function (acc, recipe) {
                if (recipe[id]) {
                  var value = recipe[id];
                  if (typeof value === "string") acc.push(value);else if (Array.isArray(value) && value.some(function (el) {
                    return typeof el === "object" && isTool(el);
                  })) value.map(function (el) {
                    return acc.push(el.name);
                  });else if (Array.isArray(value)) acc.push.apply(acc, (0,toConsumableArray/* default */.Z)(value));else {
                    throw new Error("Unexpected value type for filter ".concat(id));
                  }
                }

                return acc;
              }, []);
              return {
                id: id,
                searchableId: searchableId,
                displayName: displayName,
                options: sortBy_default()(Array.from(new Set(options)).map(function (option) {
                  return {
                    value: option,
                    text: option
                  };
                }), function (opt) {
                  return opt.value.toLowerCase();
                })
              };
            });
            return _context3.abrupt("return", filters);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchFilters(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ../../libs/api/routes/recipes/queries/allRecipesQuery.ts



var createAllRecipesQuery = function createAllRecipesQuery(client) {
  return [["recipes", "allRecipesQuery"], function () {
    return fetchAllRecipes(client);
  }];
};
var useAllRecipesQuery = (0,createQueryHook/* default */.Z)(createAllRecipesQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/routes/recipes/queries/featuredRecipesQuery.ts



var createFeaturedRecipesQuery = function createFeaturedRecipesQuery(client, _ref) {
  var max = _ref.max;
  return [["recipes", "featuredRecipesQuery", max], function (_ref2) {
    var signal = _ref2.signal;
    return fetchFeaturedRecipes({
      client: client,
      max: max,
      options: {
        signal: signal
      }
    });
  }];
};
var useFeaturedRecipesQuery = (0,createQueryHook/* default */.Z)(createFeaturedRecipesQuery, staticSiteBackend/* useStaticSiteBackend */.gR);
;// CONCATENATED MODULE: ../../libs/api/routes/recipes/queries/filtersQuery.ts



var defaultFilters = [{
  id: "roles",
  searchableId: "teams",
  displayName: "Teams"
}, {
  id: "experienceLevel",
  searchableId: "experienceLevel",
  displayName: "Experience Level"
}, {
  id: "industries",
  searchableId: "industries",
  displayName: "Industry"
}, {
  id: "requiredTools",
  searchableId: "requiredTools.name",
  displayName: "Tools"
}];
var createFiltersQuery = function createFiltersQuery(client) {
  var filtersObjs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultFilters;
  return [["recipes", "filters"], function (_ref) {
    var signal = _ref.signal;
    return fetchFilters({
      client: client,
      filtersObjs: filtersObjs,
      options: {
        signal: signal
      }
    });
  }];
};
var useFiltersQuery = (0,createQueryHook/* default */.Z)(createFiltersQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
// EXTERNAL MODULE: ../../libs/utils/createInfinityQueryHook/createInfinityQueryHook.ts
var createInfinityQueryHook = __webpack_require__(99338);
// EXTERNAL MODULE: ../../libs/utils/fsCache/index.ts
var fsCache = __webpack_require__(96904);
;// CONCATENATED MODULE: ../../libs/api/algolia/recipes.ts
/* provided dependency */ var process = __webpack_require__(34406);





function recipes_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function recipes_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? recipes_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : recipes_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var attributesToFetch = ["slug", "title", "description", "roles", "authors", "industries", "teams", "experienceLevel"];
var fetchRecipes = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var query, searchIndex, _ref$page, page, _ref$distinct, distinct, hitsPerPage, filters, cacheKey, enabled, algoliaCachedSearch;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            query = _ref.query, searchIndex = _ref.searchIndex, _ref$page = _ref.page, page = _ref$page === void 0 ? 0 : _ref$page, _ref$distinct = _ref.distinct, distinct = _ref$distinct === void 0 ? 0 : _ref$distinct, hitsPerPage = _ref.hitsPerPage, filters = _ref.filters, cacheKey = _ref.cacheKey;
            enabled = Boolean(process.env.ENABLE_FS_CACHE);
            _context.next = 4;
            return (0,fsCache/* createFsCacheProxy */.c)(["recipes-fetchRecipes"].concat((0,toConsumableArray/* default */.Z)(cacheKey ? cacheKey : [query, page !== null && page !== void 0 ? page : null, distinct !== null && distinct !== void 0 ? distinct : null, hitsPerPage !== null && hitsPerPage !== void 0 ? hitsPerPage : null, filters !== null && filters !== void 0 ? filters : null])), function () {
              return searchIndex.search.apply(searchIndex, arguments).then(function (res) {
                return recipes_objectSpread(recipes_objectSpread({}, res), {}, {
                  hits: res.hits.map(function (hit) {
                    var _hit$authors;

                    return recipes_objectSpread(recipes_objectSpread({}, hit), {}, {
                      authors: (_hit$authors = hit.authors) === null || _hit$authors === void 0 ? void 0 : _hit$authors.map(function (author) {
                        return recipes_objectSpread(recipes_objectSpread({}, author), {}, {
                          headshot: {
                            title: author.headshot.fields.title,
                            src: author.headshot.fields.file.url
                          }
                        });
                      })
                    });
                  })
                });
              });
            }, {
              enabled: enabled
            });

          case 4:
            algoliaCachedSearch = _context.sent;
            return _context.abrupt("return", algoliaCachedSearch(query, {
              attributesToRetrieve: ["-*"].concat(attributesToFetch),
              distinct: distinct,
              page: page,
              hitsPerPage: hitsPerPage,
              filters: filters
            }));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchRecipes(_x) {
    return _ref2.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ../../libs/api/routes/recipes/contexts/algoliaClientContext.ts
var algoliaClientContext = __webpack_require__(57447);
;// CONCATENATED MODULE: ../../libs/api/routes/recipes/queries/recipesQuery.ts





var createRecipesQuery = function createRecipesQuery(searchIndex, _ref) {
  var query = _ref.query,
      hitsPerPage = _ref.hitsPerPage,
      filters = _ref.filters;
  return [["recipes", "recipesQuery", query, hitsPerPage, filters], /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref2) {
      var pageParam;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              pageParam = _ref2.pageParam;
              return _context.abrupt("return", fetchRecipes({
                searchIndex: searchIndex,
                page: pageParam,
                query: query,
                filters: filters,
                hitsPerPage: 6
              }));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }()];
};
var useRecipesQuery = (0,createInfinityQueryHook/* default */.Z)(createRecipesQuery, algoliaClientContext/* useRecipesIndex */.ei, {
  staleTime: Infinity,
  getPreviousPageParam: function getPreviousPageParam(_ref4) {
    var _ref4$page = _ref4.page,
        page = _ref4$page === void 0 ? 0 : _ref4$page;
    var prevPage = page - 1;

    if (prevPage < 0) {
      return;
    }

    return prevPage;
  },
  getNextPageParam: function getNextPageParam(_ref5) {
    var _ref5$page = _ref5.page,
        page = _ref5$page === void 0 ? 0 : _ref5$page,
        nbPages = _ref5.nbPages;
    var nextPage = page + 1;

    if (nextPage >= nbPages) {
      return;
    }

    return nextPage;
  }
});
;// CONCATENATED MODULE: ../../libs/api/routes/recipes/queries/singleRecipeQuery.ts



var createSingleRecipeQuery = function createSingleRecipeQuery(client, slug) {
  return [["recipes/singleRecipeQuery", slug], function () {
    return fetchRecipe({
      client: client,
      slug: slug
    });
  }];
};
var useSingleRecipeQuery = (0,createQueryHook/* default */.Z)(createSingleRecipeQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/routes/recipes/queries/index.ts






/***/ }),

/***/ 86708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D1": function() { return /* binding */ StaticSiteBackendProvider; },
/* harmony export */   "I4": function() { return /* binding */ createStaticSiteBackend; },
/* harmony export */   "gR": function() { return /* binding */ useStaticSiteBackend; }
/* harmony export */ });
/* unused harmony export StaticSiteBackendContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _segment_api_staticSiteBackend_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39896);


var StaticSiteBackendContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var StaticSiteBackendProvider = StaticSiteBackendContext.Provider;
var useStaticSiteBackend = function useStaticSiteBackend() {
  var staticSiteBackend = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(StaticSiteBackendContext);

  if (!staticSiteBackend) {
    throw new Error("Static site backend isn't available. Please set it via StaticSiteBackendProvider component.");
  }

  return staticSiteBackend;
}; // Helper method to simplify importing

var createStaticSiteBackend = function createStaticSiteBackend() {
  return (0,_segment_api_staticSiteBackend_client__WEBPACK_IMPORTED_MODULE_1__/* .createClient */ .e)();
};

/***/ }),

/***/ 33514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Dx; },
/* harmony export */   "Hq": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Hq; },
/* harmony export */   "ZP": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Ob; },
/* harmony export */   "h4": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.h4; },
/* harmony export */   "uT": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.uT; },
/* harmony export */   "xv": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.xv; }
/* harmony export */ });
/* harmony import */ var _FeatureBox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13379);

_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .FeatureBox.displayName */ .Ob.displayName = "FeatureBoxBase";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Body.displayName */ .uT.displayName = "FeatureBox.Body";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Header.displayName */ .h4.displayName = "FeatureBox.Header";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Text.displayName */ .xv.displayName = "FeatureBox.Text";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Title.displayName */ .Dx.displayName = "FeatureBox.Title";


/***/ }),

/***/ 79600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ components_IconWrapper_IconWrapper; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../libs/matcha/components/IconWrapper/IconWrapper.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var IconWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1bo4d8j1"
} : 0)("width:44px;height:44px;border-radius:50%;color:", function (_ref2) {
  var color = _ref2.color;
  return color;
}, ";background-color:", function (_ref3) {
  var backgroundColor = _ref3.backgroundColor;
  return backgroundColor;
}, ";", function (_ref4) {
  var elevation = _ref4.elevation,
      theme = _ref4.theme;
  return elevation &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("box-shadow:", theme.shadows[elevation], ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));

var _ref =  true ? {
  name: "1iixa1j",
  styles: "width:40px;height:40px;svg{width:40px;height:40px;}padding:2px"
} : 0;

var Icon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1bo4d8j0"
} : 0)("display:block;width:24px;height:24px;padding:10px;", function (_ref5) {
  var variant = _ref5.variant;
  return variant === "transparent" && _ref;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/IconWrapper/IconWrapper.tsx


var _excluded = ["tokens", "variant", "elevation", "className", "tag", "children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseIconWrapper = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      variant = _ref.variant,
      elevation = _ref.elevation,
      className = _ref.className,
      tag = _ref.tag,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper, _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    className: className,
    elevation: elevation,
    as: tag
  }, tokens), rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
      variant: variant,
      children: children
    })
  }));
});

var getBackgroundPropTokens = function getBackgroundPropTokens(background, theme) {
  switch (background) {
    case "white":
      return {
        backgroundColor: theme.palette.neutrals.white[100],
        color: theme.palette.brand.boysenberry[500]
      };

    case "light":
      return {
        backgroundColor: theme.palette.brand.boysenberry[100],
        color: theme.palette.brand.darkAcai[700]
      };

    case "dark":
      return {
        backgroundColor: theme.palette.brand.darkAcai[600],
        color: theme.palette.brand.boysenberry[200]
      };

    default:
      return {
        backgroundColor: theme.palette.neutrals.white[100],
        color: theme.palette.twilio.gray[100]
      };
  }
};

var IconWrapper_IconWrapper = (0,useDesignTokens/* withDesignTokens */.Y)(BaseIconWrapper, function (_ref2) {
  var elevation = _ref2.elevation;
  return {
    elevation: elevation
  };
}, {
  light: function light(theme, props) {
    if (props.variant === "transparent") {
      return {
        color: theme.palette.brand.darkAcai[700],
        backgroundColor: "transparent"
      };
    }

    if (props.background) {
      return getBackgroundPropTokens(props.background, theme);
    }

    return {
      color: theme.palette.brand.darkAcai[700],
      backgroundColor: theme.palette.brand.boysenberry[100]
    };
  },
  dark: function dark(theme, props) {
    if (props.variant === "transparent") {
      return {
        color: theme.palette.neutrals.white[100],
        backgroundColor: "transparent"
      };
    }

    if (props.background) {
      return getBackgroundPropTokens(props.background, theme);
    }

    return {
      color: theme.palette.brand.boysenberry[200],
      backgroundColor: theme.palette.brand.darkAcai[600]
    };
  },
  twilioLight: function twilioLight(theme, props) {
    if (props.variant === "transparent") {
      return {
        color: theme.palette.twilio.gray[100],
        backgroundColor: "transparent"
      };
    }

    if (props.background) {
      return getBackgroundPropTokens(props.background, theme);
    }

    return {
      color: theme.palette.twilio.gray[100],
      backgroundColor: theme.palette.neutrals.white[100]
    };
  }
});
/* harmony default export */ var components_IconWrapper_IconWrapper = (IconWrapper_IconWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/components/IconWrapper/index.ts


/***/ }),

/***/ 80077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qE": function() { return /* reexport */ Avatar; },
  "uT": function() { return /* reexport */ Body; },
  "dk": function() { return /* reexport */ AuthorCard_Description; },
  "VG": function() { return /* reexport */ Name; },
  "ZP": function() { return /* reexport */ AuthorCard; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/withDesignTokens.tsx
var withDesignTokens = __webpack_require__(72300);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../libs/matcha/components/Paper/index.ts + 2 modules
var Paper = __webpack_require__(16164);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/AuthorCard/AuthorCard.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}





var Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e3dd55v4"
} : 0)("width:100%;text-align:left;margin-top:4px;transition:color 0.3s ease;color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";" + ( true ? "" : 0));
var BodyWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e3dd55v3"
} : 0)( true ? "" : 0);
var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Paper/* default */.Z,  true ? {
  target: "e3dd55v2"
} : 0)("display:grid;grid-auto-flow:column;justify-content:start;gap:16px;align-items:center;width:auto;background-color:", function (_ref2) {
  var backgroundColor = _ref2.backgroundColor;
  return backgroundColor;
}, ";color:", function (_ref3) {
  var color = _ref3.color;
  return color;
}, ";", function (_ref4) {
  var variant = _ref4.variant,
      theme = _ref4.theme;
  return variant === "filled" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)(theme.shadows[2], ";padding:18px 16px;" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));
var Name = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e3dd55v1"
} : 0)(function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.textBoldSmall.css;
}, ";width:100%;text-align:left;transition:color 0.3s ease;" + ( true ? "" : 0));
var Avatar = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e3dd55v0"
} : 0)( true ? {
  name: "qzff0m",
  styles: "border-radius:50%;max-width:48px;max-height:48px;object-fit:cover"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/AuthorCard/AuthorCard.tsx


var _excluded = ["children", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseAuthorCard = function BaseAuthorCard(_ref) {
  var externalAppearance = _ref.appearance,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      children = _ref.children,
      tokens = _ref.tokens;
  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, _objectSpread(_objectSpread({}, tokens), {}, {
    variant: variant,
    appearance: appearance,
    children: children
  }));
};

var BaseDescription = function BaseDescription(_ref2) {
  var children = _ref2.children,
      tokens = _ref2.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, _objectSpread(_objectSpread({
    tokens: tokens,
    variant: "textTiny"
  }, rest), {}, {
    children: children
  }));
};

var AuthorCard_Description = (0,withDesignTokens/* default */.Z)(BaseDescription, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[50]
    };
  }
});
var Body = function Body(_ref3) {
  var children = _ref3.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BodyWrapper, {
    children: children
  });
};
var AuthorCard = (0,withDesignTokens/* default */.Z)(BaseAuthorCard, function (_ref4) {
  var variant = _ref4.variant;
  return {
    variant: variant
  };
}, {
  light: function light(theme, _ref5) {
    var variant = _ref5.variant;

    if (variant === "filled") {
      return {
        backgroundColor: theme.palette.neutrals.white[100],
        color: theme.palette.brand.boysenberry[400]
      };
    }

    return {
      backgroundColor: "transparent",
      color: theme.palette.brand.boysenberry[400]
    };
  },
  dark: function dark(theme, _ref6) {
    var variant = _ref6.variant;

    if (variant === "filled") {
      return {
        backgroundColor: theme.palette.neutrals.cloud[100],
        color: theme.palette.brand.boysenberry[400]
      };
    }

    return {
      backgroundColor: "transparent",
      color: theme.palette.brand.boysenberry[300]
    };
  },
  twilioLight: function twilioLight(theme, _ref7) {
    var variant = _ref7.variant;

    if (variant === "filled") {
      return {
        backgroundColor: theme.palette.neutrals.white[100],
        color: theme.palette.twilio.gray[100]
      };
    }

    return {
      backgroundColor: "transparent",
      color: theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var AuthorCard_AuthorCard = ((/* unused pure expression or super */ null && (AuthorCard)));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/AuthorCard/index.ts


AuthorCard.displayName = "AuthorCardBase";
Avatar.displayName = "AuthorCard.Avatar";
Body.displayName = "AuthorCard.Body";
Name.displayName = "AuthorCard.Name";
AuthorCard_Description.displayName = "AuthorCard.Description";


/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 56052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Layout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6372);


/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 42576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ GettingStarted; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.views.tsx

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v2"
} : 0)("overflow-y:auto;overflow-x:hidden;padding-top:80px;background:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";" + ( true ? "" : 0));
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v1"
} : 0)("display:grid;justify-content:center;row-gap:40px;padding:0 20px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 80px 30px;}" + ( true ? "" : 0));
var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v0"
} : 0)("display:grid;max-width:540px;width:100%;margin:0 auto;grid-template-columns:1fr 1fr;grid-template-rows:auto;gap:24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{grid-template-columns:auto;max-width:327px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}













var BaseGettingStarted = function BaseGettingStarted(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Getting started is easy" : _ref$heading,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? "Start connecting your data with Segment." : _ref$description,
      _ref$demoUtms = _ref.demoUtms,
      demoUtms = _ref$demoUtms === void 0 ? "" : _ref$demoUtms,
      tokens = _ref.tokens;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, tokens), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h2",
          children: heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/demo/".concat(demoUtms), pageConfig),
          children: "Get a demo"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
          tag: "a",
          variant: "outlined",
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "Create a free account"
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})]
  }));
};

var GettingStarted = (0,useDesignTokens/* withDesignTokens */.Y)(BaseGettingStarted, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.neutrals.cloud[100]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.twilio.gray[10]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/index.ts


/***/ }),

/***/ 99338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58586);



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


/**
 * Creates infinite query hook from query factory
 *
 * @param fetchFactory factory function creating [query key, fetchFunction] tuple for use with react-query lib
 * @param useClientInstance hook function returning client instance to use with fetching function
 * @returns hook function wrapping useInfiniteQuery
 */

var createInfiniteQueryHook = function createInfiniteQueryHook(fetchFactory, useClientInstance, defaultOptions) {
  return function (_ref) {
    var args = _ref.args,
        options = _ref.options;
    var instance = useClientInstance();
    return _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useInfiniteQuery.apply */ .N.apply(void 0, (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fetchFactory.apply(void 0, [instance].concat((0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(args)))).concat([_objectSpread(_objectSpread({}, defaultOptions), options)]));
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (createInfiniteQueryHook);

/***/ }),

/***/ 74048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58943);



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


/**
 * Creates query hook from query factory
 *
 * @param fetchFactory factory function creating [query key, fetchFunction] tuple for use with react-query lib
 * @param useClientInstance hook function returning client instance to use with fetching function
 * @returns hook function wrapping useQuery
 */

var createQueryHook = function createQueryHook(fetchFactory, useClientInstance, defaultOptions) {
  return function (_ref) {
    var args = _ref.args,
        options = _ref.options;
    var instance = useClientInstance();
    return _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery.apply */ .a.apply(void 0, (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fetchFactory.apply(void 0, [instance].concat((0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(args)))).concat([_objectSpread(_objectSpread({}, defaultOptions), options)]));
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (createQueryHook);

/***/ }),

/***/ 10715:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ createFsCacheProxy; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95922);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12741);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20406);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28526);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* module decorator */ module = __webpack_require__.hmd(module);




function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}



function _asyncIterator(iterable) {
  var method,
      async,
      sync,
      retry = 2;

  for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) {
    if (async && null != (method = iterable[async])) return method.call(iterable);
    if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable));
    async = "@@asyncIterator", sync = "@@iterator";
  }

  throw new TypeError("Object is not async iterable");
}

function AsyncFromSyncIterator(s) {
  function AsyncFromSyncIteratorContinuation(r) {
    if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
    var done = r.done;
    return Promise.resolve(r.value).then(function (value) {
      return {
        value: value,
        done: done
      };
    });
  }

  return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) {
    this.s = s, this.n = s.next;
  }, AsyncFromSyncIterator.prototype = {
    s: null,
    n: null,
    next: function next() {
      return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
    },
    "return": function _return(value) {
      var ret = this.s["return"];
      return void 0 === ret ? Promise.resolve({
        value: value,
        done: !0
      }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
    },
    "throw": function _throw(value) {
      var thr = this.s["return"];
      return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
    }
  }, new AsyncFromSyncIterator(s);
}

function maybeImport(_x) {
  return _maybeImport.apply(this, arguments);
}

function _maybeImport() {
  _maybeImport = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(importFn) {
    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return",  false ? 0 : Promise.resolve(null));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _maybeImport.apply(this, arguments);
}

function getPkgJsonDir() {
  return _getPkgJsonDir.apply(this, arguments);
}

function _getPkgJsonDir() {
  _getPkgJsonDir = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4() {
    var _yield$import, dirname, _yield$import2, constants, access, errors, _iterator3, _step3, path, prospectivePkgJsonDir;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return __webpack_require__.e(/* import() */ 5153).then(__webpack_require__.t.bind(__webpack_require__, 15153, 23));

          case 2:
            _yield$import = _context4.sent;
            dirname = _yield$import.dirname;
            _context4.next = 6;
            return __webpack_require__.e(/* import() */ 8653).then(__webpack_require__.t.bind(__webpack_require__, 68653, 23));

          case 6:
            _yield$import2 = _context4.sent;
            constants = _yield$import2.constants;
            access = _yield$import2.promises.access;
            errors = [];
            _iterator3 = _createForOfIteratorHelper(module.paths);
            _context4.prev = 11;

            _iterator3.s();

          case 13:
            if ((_step3 = _iterator3.n()).done) {
              _context4.next = 27;
              break;
            }

            path = _step3.value;
            _context4.prev = 15;
            prospectivePkgJsonDir = dirname(path); // eslint-disable-next-line no-await-in-loop

            _context4.next = 19;
            return access(path, constants.F_OK);

          case 19:
            return _context4.abrupt("return", prospectivePkgJsonDir);

          case 22:
            _context4.prev = 22;
            _context4.t0 = _context4["catch"](15);
            errors.push(_context4.t0);

          case 25:
            _context4.next = 13;
            break;

          case 27:
            _context4.next = 32;
            break;

          case 29:
            _context4.prev = 29;
            _context4.t1 = _context4["catch"](11);

            _iterator3.e(_context4.t1);

          case 32:
            _context4.prev = 32;

            _iterator3.f();

            return _context4.finish(32);

          case 35:
            throw new Error("Cannot find project root dir. Underlying errors:\n\n ".concat(errors.join("\n")));

          case 36:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[11, 29, 32, 35], [15, 22]]);
  }));
  return _getPkgJsonDir.apply(this, arguments);
}

function getCacheFilename(_x2) {
  return _getCacheFilename.apply(this, arguments);
}

function _getCacheFilename() {
  _getCacheFilename = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(key) {
    var indexKey, hashData, _key, head, tail, hashPart, crypto, hashFn, hash;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(!key.length && key.length <= 0)) {
              _context5.next = 2;
              break;
            }

            throw new Error("Cache key is empty");

          case 2:
            hashData = null;

            if (Array.isArray(key)) {
              _key = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(key), head = _key[0], tail = _key.slice(1);
              indexKey = head;
              hashData = tail;
            } else {
              indexKey = key;
            }

            hashPart = "";

            if (!(hashData && hashData.length > 0)) {
              _context5.next = 12;
              break;
            }

            _context5.next = 8;
            return maybeImport(function () {
              return Promise.all(/* import() */[__webpack_require__.e(8934), __webpack_require__.e(8834), __webpack_require__.e(8421)]).then(__webpack_require__.t.bind(__webpack_require__, 71941, 23));
            });

          case 8:
            crypto = _context5.sent;
            hashFn = crypto === null || crypto === void 0 ? void 0 : crypto.createHash("sha1");
            hash = hashFn === null || hashFn === void 0 ? void 0 : hashFn.update(hashData.map(function (v) {
              return typeof v === "string" ? v : JSON.stringify(v);
            }).join("")).digest("hex");

            if (hash) {
              hashPart = "-".concat(hash);
            }

          case 12:
            return _context5.abrupt("return", "".concat(indexKey).concat(hashPart));

          case 13:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getCacheFilename.apply(this, arguments);
}

function getDefaultCacheDirPath() {
  return _getDefaultCacheDirPath.apply(this, arguments);
}

function _getDefaultCacheDirPath() {
  _getDefaultCacheDirPath = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6() {
    var path;
    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return __webpack_require__.e(/* import() */ 5153).then(__webpack_require__.t.bind(__webpack_require__, 15153, 23));

          case 2:
            path = _context6.sent;
            _context6.t0 = path;
            _context6.next = 6;
            return getPkgJsonDir();

          case 6:
            _context6.t1 = _context6.sent;
            return _context6.abrupt("return", _context6.t0.resolve.call(_context6.t0, _context6.t1, "node_modules/.cache/fsCache"));

          case 8:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getDefaultCacheDirPath.apply(this, arguments);
}

function invariantCacheFilePresent(_x3) {
  return _invariantCacheFilePresent.apply(this, arguments);
}

function _invariantCacheFilePresent() {
  _invariantCacheFilePresent = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee7(cacheFilePath) {
    var _yield$import3, constants, fs;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return __webpack_require__.e(/* import() */ 8653).then(__webpack_require__.t.bind(__webpack_require__, 68653, 23));

          case 2:
            _yield$import3 = _context7.sent;
            constants = _yield$import3.constants;
            fs = _yield$import3.promises;
            _context7.next = 7;
            return fs.access(cacheFilePath, constants.F_OK);

          case 7:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _invariantCacheFilePresent.apply(this, arguments);
}

function ensureCacheDirExists(_x4) {
  return _ensureCacheDirExists.apply(this, arguments);
}

function _ensureCacheDirExists() {
  _ensureCacheDirExists = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee8(cacheDirPath) {
    var _yield$import4, constants, fs;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return __webpack_require__.e(/* import() */ 8653).then(__webpack_require__.t.bind(__webpack_require__, 68653, 23));

          case 2:
            _yield$import4 = _context8.sent;
            constants = _yield$import4.constants;
            fs = _yield$import4.promises;
            _context8.prev = 5;
            _context8.next = 8;
            return fs.access(cacheDirPath, constants.F_OK);

          case 8:
            _context8.next = 18;
            break;

          case 10:
            _context8.prev = 10;
            _context8.t0 = _context8["catch"](5);

            if (!(_context8.t0.code === "ENOENT")) {
              _context8.next = 17;
              break;
            }

            _context8.next = 15;
            return fs.mkdir(cacheDirPath, {
              recursive: true
            });

          case 15:
            _context8.next = 18;
            break;

          case 17:
            throw _context8.t0;

          case 18:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[5, 10]]);
  }));
  return _ensureCacheDirExists.apply(this, arguments);
}

function isCacheStale(metadata, staleTime) {
  return metadata.time - Date.now() + staleTime * 1000 < 0;
}

function loadCacheMetadata(_x5) {
  return _loadCacheMetadata.apply(this, arguments);
}

function _loadCacheMetadata() {
  _loadCacheMetadata = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee9(cacheFilePath) {
    var fs, readline, readable, readInterface, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, line;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return __webpack_require__.e(/* import() */ 8653).then(__webpack_require__.t.bind(__webpack_require__, 68653, 23));

          case 2:
            fs = _context9.sent;
            _context9.next = 5;
            return __webpack_require__.e(/* import() */ 6757).then(__webpack_require__.t.bind(__webpack_require__, 16757, 23));

          case 5:
            readline = _context9.sent;
            readable = fs.createReadStream(cacheFilePath);
            readInterface = readline.createInterface({
              input: readable,
              crlfDelay: Infinity
            }); // eslint-disable-next-line no-unreachable-loop

            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context9.prev = 10;
            _iterator = _asyncIterator(readInterface);

          case 12:
            _context9.next = 14;
            return _iterator.next();

          case 14:
            if (!(_iteratorAbruptCompletion = !(_step = _context9.sent).done)) {
              _context9.next = 20;
              break;
            }

            line = _step.value;
            return _context9.abrupt("return", JSON.parse(line));

          case 17:
            _iteratorAbruptCompletion = false;
            _context9.next = 12;
            break;

          case 20:
            _context9.next = 26;
            break;

          case 22:
            _context9.prev = 22;
            _context9.t0 = _context9["catch"](10);
            _didIteratorError = true;
            _iteratorError = _context9.t0;

          case 26:
            _context9.prev = 26;
            _context9.prev = 27;

            if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) {
              _context9.next = 31;
              break;
            }

            _context9.next = 31;
            return _iterator["return"]();

          case 31:
            _context9.prev = 31;

            if (!_didIteratorError) {
              _context9.next = 34;
              break;
            }

            throw _iteratorError;

          case 34:
            return _context9.finish(31);

          case 35:
            return _context9.finish(26);

          case 36:
            throw new Error("Cannot load cache metadata");

          case 37:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[10, 22, 26, 36], [27,, 31, 35]]);
  }));
  return _loadCacheMetadata.apply(this, arguments);
}

function loadCachedData(_x6) {
  return _loadCachedData.apply(this, arguments);
}

function _loadCachedData() {
  _loadCachedData = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee10(cacheFilePath) {
    var fs, readline, readable, readInterface, data, isFirstLine, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, line;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return __webpack_require__.e(/* import() */ 8653).then(__webpack_require__.t.bind(__webpack_require__, 68653, 23));

          case 2:
            fs = _context10.sent;
            _context10.next = 5;
            return __webpack_require__.e(/* import() */ 6757).then(__webpack_require__.t.bind(__webpack_require__, 16757, 23));

          case 5:
            readline = _context10.sent;
            readable = fs.createReadStream(cacheFilePath);
            readInterface = readline.createInterface({
              input: readable,
              crlfDelay: Infinity
            });
            data = "";
            isFirstLine = true;
            _iteratorAbruptCompletion2 = false;
            _didIteratorError2 = false;
            _context10.prev = 12;
            _iterator2 = _asyncIterator(readInterface);

          case 14:
            _context10.next = 16;
            return _iterator2.next();

          case 16:
            if (!(_iteratorAbruptCompletion2 = !(_step2 = _context10.sent).done)) {
              _context10.next = 25;
              break;
            }

            line = _step2.value;

            if (!isFirstLine) {
              _context10.next = 21;
              break;
            }

            isFirstLine = false;
            return _context10.abrupt("continue", 22);

          case 21:
            data += line;

          case 22:
            _iteratorAbruptCompletion2 = false;
            _context10.next = 14;
            break;

          case 25:
            _context10.next = 31;
            break;

          case 27:
            _context10.prev = 27;
            _context10.t0 = _context10["catch"](12);
            _didIteratorError2 = true;
            _iteratorError2 = _context10.t0;

          case 31:
            _context10.prev = 31;
            _context10.prev = 32;

            if (!(_iteratorAbruptCompletion2 && _iterator2["return"] != null)) {
              _context10.next = 36;
              break;
            }

            _context10.next = 36;
            return _iterator2["return"]();

          case 36:
            _context10.prev = 36;

            if (!_didIteratorError2) {
              _context10.next = 39;
              break;
            }

            throw _iteratorError2;

          case 39:
            return _context10.finish(36);

          case 40:
            return _context10.finish(31);

          case 41:
            return _context10.abrupt("return", JSON.parse(data));

          case 42:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[12, 27, 31, 41], [32,, 36, 40]]);
  }));
  return _loadCachedData.apply(this, arguments);
}

function isSubDir(_x7, _x8) {
  return _isSubDir.apply(this, arguments);
}
/**
 * Creates a file system cache function proxy. It stores function results in the
 * file system and reuses them as long as they are fresh. Useful to cache heavy
 * network requests while building static page via NextJS. Each function with
 * unique key is stored as a separate entry in a location set via options.
 *
 * @param key - globally unique caching key
 * @param fn - fetching function which returned data will be cached
 * @param opts - options object
 * @returns function proxy with caching layer
 */


function _isSubDir() {
  _isSubDir = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee11(parent, dir) {
    var path, relative;
    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return __webpack_require__.e(/* import() */ 5153).then(__webpack_require__.t.bind(__webpack_require__, 15153, 23));

          case 2:
            path = _context11.sent;
            relative = path.relative(parent, dir);
            return _context11.abrupt("return", relative && !relative.startsWith("..") && !path.isAbsolute(relative));

          case 5:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _isSubDir.apply(this, arguments);
}

var createFsCacheProxy = /*#__PURE__*/function () {
  var _ref2 = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(key, fn, _ref) {
    var enabled, _ref$staleTime, staleTime, _ref$cacheDirPath, userCacheDirPath, fsClassic, path, fs, cacheDirPath, cacheFilename, cacheFilePath, targetCacheDirPath;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            enabled = _ref.enabled, _ref$staleTime = _ref.staleTime, staleTime = _ref$staleTime === void 0 ? 300 : _ref$staleTime, _ref$cacheDirPath = _ref.cacheDirPath, userCacheDirPath = _ref$cacheDirPath === void 0 ? "/workdir/apps/segment/node_modules/.cache/fsCache" : _ref$cacheDirPath;
            _context2.next = 3;
            return maybeImport(function () {
              return __webpack_require__.e(/* import() */ 8653).then(__webpack_require__.t.bind(__webpack_require__, 68653, 23));
            });

          case 3:
            fsClassic = _context2.sent;
            _context2.next = 6;
            return maybeImport(function () {
              return __webpack_require__.e(/* import() */ 5153).then(__webpack_require__.t.bind(__webpack_require__, 15153, 23));
            });

          case 6:
            path = _context2.sent;

            if (!(!fsClassic || !path || !enabled || true)) {}

            return _context2.abrupt("return", fn);

          case 9:
            fs = fsClassic.promises;
            _context2.t0 = path;

            if (!(userCacheDirPath !== null && userCacheDirPath !== void 0)) {
              _context2.next = 15;
              break;
            }

            _context2.t1 = userCacheDirPath;
            _context2.next = 18;
            break;

          case 15:
            _context2.next = 17;
            return getDefaultCacheDirPath();

          case 17:
            _context2.t1 = _context2.sent;

          case 18:
            _context2.t2 = _context2.t1;
            cacheDirPath = _context2.t0.resolve.call(_context2.t0, _context2.t2);
            _context2.next = 22;
            return getCacheFilename(key);

          case 22:
            cacheFilename = _context2.sent;
            cacheFilePath = path.resolve(cacheDirPath, cacheFilename);
            targetCacheDirPath = path.dirname(cacheFilePath);
            _context2.t3 = cacheDirPath !== targetCacheDirPath;

            if (!_context2.t3) {
              _context2.next = 30;
              break;
            }

            _context2.next = 29;
            return isSubDir(cacheDirPath, targetCacheDirPath);

          case 29:
            _context2.t3 = !_context2.sent;

          case 30:
            if (!_context2.t3) {
              _context2.next = 32;
              break;
            }

            throw new Error("Cache file tries to jailbreak cache dir. Make sure that cache key doesn't start with eg. \"../\".");

          case 32:
            return _context2.abrupt("return", new Proxy(fn, {
              apply: function apply(target, _that, args) {
                return (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                  var metadata, isCacheStaleValue, result, newCacheMetadata, stringifiedMetadata, dataToCache, cachePayload;
                  return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          _context.next = 3;
                          return invariantCacheFilePresent(cacheFilePath);

                        case 3:
                          _context.next = 5;
                          return loadCacheMetadata(cacheFilePath);

                        case 5:
                          metadata = _context.sent;
                          _context.next = 8;
                          return isCacheStale(metadata, staleTime);

                        case 8:
                          isCacheStaleValue = _context.sent;

                          if (isCacheStaleValue) {
                            _context.next = 11;
                            break;
                          }

                          return _context.abrupt("return", loadCachedData(cacheFilePath));

                        case 11:
                          _context.next = 15;
                          break;

                        case 13:
                          _context.prev = 13;
                          _context.t0 = _context["catch"](0);

                        case 15:
                          _context.next = 17;
                          return target.apply(void 0, (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(args));

                        case 17:
                          result = _context.sent;
                          newCacheMetadata = {
                            time: Date.now()
                          };
                          stringifiedMetadata = JSON.stringify(newCacheMetadata);
                          _context.prev = 20;
                          dataToCache = JSON.stringify(result);
                          _context.next = 27;
                          break;

                        case 24:
                          _context.prev = 24;
                          _context.t1 = _context["catch"](20);
                          throw new Error("Failed to JSON stringify result. Caching only supported for simple data.\n\n Inner exception: \n".concat(dataToCache));

                        case 27:
                          cachePayload = stringifiedMetadata + "\n" + dataToCache;
                          _context.next = 30;
                          return ensureCacheDirExists(targetCacheDirPath);

                        case 30:
                          _context.next = 32;
                          return fs.writeFile(cacheFilePath, cachePayload, {
                            encoding: "utf8"
                          });

                        case 32:
                          return _context.abrupt("return", result);

                        case 33:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[0, 13], [20, 24]]);
                }))();
              }
            }));

          case 33:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function createFsCacheProxy(_x9, _x10, _x11) {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),

/***/ 96904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* reexport safe */ _fsCache__WEBPACK_IMPORTED_MODULE_0__.c; }
/* harmony export */ });
/* harmony import */ var _fsCache__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10715);


/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ }),

/***/ 43906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useRichTextTableOfContent_useRichTextTableOfContent; },
  "q": function() { return /* reexport */ getNodeText; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(82562);
;// CONCATENATED MODULE: ../../libs/utils/useRichTextTableOfContent/useRichTextTableOfContent.tsx


var getNodeText = function getNodeText(element) {
  return element.content.map(function (innerNode) {
    return innerNode.nodeType === "text" ? innerNode.value : "";
  }).join();
};

var createState = function createState(data, _ref) {
  var nodeTypesHierarchy = _ref.nodeTypesHierarchy;
  var usedIds = new Set();
  var stateArray = nodeTypesHierarchy.map(function (nodeType) {
    var state = new Map();
    data === null || data === void 0 ? void 0 : data.content.forEach(function (element) {
      if (nodeType === element.nodeType) {
        var text = getNodeText(element);
        var slugBase = text.toLocaleLowerCase().replace(/[^A-Za-z0-9 \s]/g, "").split(" ").join("-");

        if (slugBase.match(/^\d/)) {
          slugBase = slugBase.replace(/^[0-9]+/, "");
          slugBase = slugBase.startsWith("-") ? slugBase.replace("-", "") : slugBase;
        }

        var slug = slugBase;
        var i = 1;

        while (usedIds.has(slug)) {
          slug = "".concat(slugBase, "-").concat(i++);
        }

        usedIds.add(slug);
        state.set(element, slug);
      }
    });
    return state;
  });
  return stateArray;
};

var defaultNodeTypesHierarchy = [dist.BLOCKS.HEADING_2];
/**
 * A hook that creates a table of content state from a rich text document.
 * @param data The rich text document to create the table of content state from.
 * @param options The options to use when creating the table of content state.
 * @returns The table of content state.
 */

var useRichTextTableOfContent = function useRichTextTableOfContent(data) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$nodeTypesHierar = _ref2.nodeTypesHierarchy,
      nodeTypesHierarchy = _ref2$nodeTypesHierar === void 0 ? defaultNodeTypesHierarchy : _ref2$nodeTypesHierar;

  var _useState = (0,react.useState)(function () {
    return createState(data, {
      nodeTypesHierarchy: nodeTypesHierarchy
    });
  }),
      state = _useState[0],
      setState = _useState[1];

  (0,react.useEffect)(function () {
    setState(createState(data, {
      nodeTypesHierarchy: nodeTypesHierarchy
    }));
  }, [data, nodeTypesHierarchy]);
  return (0,react.useMemo)(function () {
    return {
      getId: function getId(node) {
        var _state$find;

        return (_state$find = state.find(function (levelState) {
          return levelState.get(node);
        })) === null || _state$find === void 0 ? void 0 : _state$find.get(node);
      },
      getMenuLevelItems: function getMenuLevelItems(level) {
        return Array.from(state[level].entries());
      }
    };
  }, [state]);
};

/* harmony default export */ var useRichTextTableOfContent_useRichTextTableOfContent = (useRichTextTableOfContent);
;// CONCATENATED MODULE: ../../libs/utils/useRichTextTableOfContent/index.ts


/***/ }),

/***/ 63356:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recipes/[slug]",
      function () {
        return __webpack_require__(87993);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 58586:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ useInfiniteQuery; }
});

// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(36370);
// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/queryObserver.mjs
var queryObserver = __webpack_require__(91578);
// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/infiniteQueryBehavior.mjs
var infiniteQueryBehavior = __webpack_require__(54388);
;// CONCATENATED MODULE: ../../node_modules/@tanstack/query-core/build/lib/infiniteQueryObserver.mjs



class InfiniteQueryObserver extends queryObserver/* QueryObserver */.z {
  // Type override
  // Type override
  // Type override
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(client, options) {
    super(client, options);
  }

  bindMethods() {
    super.bindMethods();
    this.fetchNextPage = this.fetchNextPage.bind(this);
    this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  }

  setOptions(options, notifyOptions) {
    super.setOptions({ ...options,
      behavior: (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)()
    }, notifyOptions);
  }

  getOptimisticResult(options) {
    options.behavior = (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)();
    return super.getOptimisticResult(options);
  }

  fetchNextPage({
    pageParam,
    ...options
  } = {}) {
    return this.fetch({ ...options,
      meta: {
        fetchMore: {
          direction: 'forward',
          pageParam
        }
      }
    });
  }

  fetchPreviousPage({
    pageParam,
    ...options
  } = {}) {
    return this.fetch({ ...options,
      meta: {
        fetchMore: {
          direction: 'backward',
          pageParam
        }
      }
    });
  }

  createResult(query, options) {
    var _state$data, _state$data2, _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet;

    const {
      state
    } = query;
    const result = super.createResult(query, options);
    return { ...result,
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: (0,infiniteQueryBehavior/* hasNextPage */.Qy)(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
      hasPreviousPage: (0,infiniteQueryBehavior/* hasPreviousPage */.ZF)(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
      isFetchingNextPage: state.fetchStatus === 'fetching' && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === 'forward',
      isFetchingPreviousPage: state.fetchStatus === 'fetching' && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === 'backward'
    };
  }

}


//# sourceMappingURL=infiniteQueryObserver.mjs.map

// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useBaseQuery.mjs + 4 modules
var useBaseQuery = __webpack_require__(53997);
;// CONCATENATED MODULE: ../../node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs



function useInfiniteQuery(arg1, arg2, arg3) {
  const options = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return (0,useBaseQuery/* useBaseQuery */.r)(options, InfiniteQueryObserver);
}


//# sourceMappingURL=useInfiniteQuery.mjs.map


/***/ }),

/***/ 95922:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _toArray; }
/* harmony export */ });
/* harmony import */ var _arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64034);
/* harmony import */ var _iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17602);
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57211);
/* harmony import */ var _nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42330);




function _toArray(arr) {
  return (0,_arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr) || (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr) || (0,_nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,3254,9129,8943,6234,4136,2073,6784,8392,5735,2429,2609,948,8187,3996,7947,7960,6012,442,3379,9550,5979,9774,2888,179], function() { return __webpack_exec__(63356); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);